export const withApiAuthorization = ({ url, options = {}, serverUrl, token }) => {
  const configuredBase = String(serverUrl || "").replace(/\/$/, "");
  const target = String(url);
  if (!configuredBase || !target.startsWith(`${configuredBase}/`) || !token) return options;
  return {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  };
};

export const createAuthenticatedFetch = ({ serverUrl, getToken, fetchImpl = globalThis.fetch }) => (
  url,
  options = {},
) => fetchImpl(url, withApiAuthorization({
  url,
  options,
  serverUrl,
  token: getToken?.(),
}));
